import sha256 from 'js-sha256'
import Vue from 'vue'
//파일 확장자 종류
const fileExtention = {
    image: ['jpg', 'png', 'jpeg', 'gif', 'bmp', 'jfif'],
    excel: ['xlsx', 'xlsm', 'xlsb', 'xltm', 'xlam', 'xltx', 'xls'],
    hwp: ['hwp', 'hwt'],
    ppt: ['pptx', 'pptm', 'ppt'],
    word: ['doc', 'docx'],
    zip: ['zip']
}

// 유효성검사 정규식
const timePattern = /^([1-9]|[01][0-9]|2[0-3]):([0-5][0-9])$/ // HH:MM (24시간)
const ymdPattern = /^(19|20)\d{2}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[0-1])$/ // YYYY-MM-DD
const regPattern = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi // 특수문자
const emailPattern = /.+@.+/ // EMAIl
const mobilePattern = /^\d{3}-\d{3,4}-\d{4}$/ // mobileNo
const telPattern = /^\d{2,3}-\d{3,4}-\d{4}$/ // telNo
const numPattern = /[0-9]/ //number

const weekDay = ['일', '월', '화', '수', '목', '금', '토']

String.prototype.week = function() {
    let str = null
    if (this) {
        let tmp = this.clearValue()
        let date = new Date(tmp.substr(0, 4), Number(tmp.substr(4, 2)) - 1, tmp.substr(6, 2))
        str = weekDay[date.getDay()]
    }
    return str
}

//깊은복사(배열안의 객체)
Array.prototype.deepCopy = function() {
    let copy = null
    if (Array.isArray(this)) {
        copy = this.slice().map((v) => {
            return {...v }
        })
    } else {
        copy = null
    }
    return copy
}

//날짜 더하기
Date.prototype.addDays = function(days) {
    this.setDate(this.getDate() + parseInt(days));
    return this;
}

//Check empty date property
Date.prototype.isEmpty = function() {
    let n = this;
    return n === "" || n === null || typeof n === "undefined" ||
        (n !== null && typeof n === 'object' && !Object.keys(val).length) ? true : false;
}

//금액 콤마추가 (keyup event)
String.prototype.amountMask = function() {
    if (!this) return this
    let val = this.replace(/[^0-9]/g, '').replace(/(^0+)/, "");
    return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        ///\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g
}

//숫자만 사용 (keyup event)
String.prototype.numMask = function() {
    if (!this) return this
    return this.replace(/[^0-9]/g, '')
}

// 숫자만 사용 (keyup event) with typeof is number
Number.prototype.numMask = function() {
    if (!this) return this
    else if (typeof this === 'number') return this
    return this.replace(/[^0-9]/g, '')
}

//날짜형식 YYYY.MM.DD (keyup event)
String.prototype.ymdMaskPoint = function() {
    let val = this
    let result = null
    if (!val) return val
    let num = val.replace(/[^0-9]/g, '')
    if (!isNaN(num.charAt(num.length - 1))) {
        if (num.length < 5) {
            result = val
        } else if (num.length < 7) {
            result = num.ymPoint()
        } else if (num.length >= 7) {
            result = num.ymdPoint()
        } else {
            result = this
        }
    } else {
        result = this.slice(0, -1)
    }
    return result
}

//날짜형식 YYYY년 MM월 DD일 (keyup event)
String.prototype.ymdMaskKor = function() {
    let val = this
    let result = null
    if (!val) return val
    let num = val.replace(/[^0-9]/g, '')
    if (!isNaN(num.charAt(num.length - 1))) {
        if (num.length < 5) {
            result = val
        } else if (num.length === 5) {
            result = num.ymKor()
        } else if (num.length >= 7) {
            result = num.ymdKor()
        } else {
            result = this
        }
    } else {
        result = this.slice(0, -1)
    }
    return result
}

//날짜형식 YYYY-MM (keyup event)
String.prototype.ymMaskKor = function() {
    let val = this
    let result = null
    if (!val) return val
    let num = val.replace(/-/g, '')
    if (!isNaN(num.charAt(num.length - 1))) {
        if (num.length < 5) {
            result = val
        } else if (num.length < 7) {
            result = num.ymKor()
        } else {
            result = this.slice(0, -1)
        }
    } else {
        result = this.slice(0, -1)
    }
    return result
}

//날짜형식 YYYY-MM-DD (keyup event)
String.prototype.ymdMask = function() {
    let val = this
    let result = null
    if (!val) return val
    let num = val.replace(/-/g, '')
    if (!isNaN(num.charAt(num.length - 1))) {
        if (num.length < 5) {
            result = val
        } else if (num.length < 7) {
            result = num.ymHyphen()
        } else if (num.length >= 7) {
            result = num.ymdHyphen()
        } else {
            result = this
        }
    } else {
        result = this.slice(0, -1)
    }
    return result
}

//날짜형식 YYYY-MM (keyup event)
String.prototype.ymMask = function() {
    let val = this
    let result = null
    if (!val) return val
    let num = val.replace(/-/g, '')
    if (!isNaN(num.charAt(num.length - 1))) {
        if (num.length < 5) {
            result = val
        } else if (num.length < 7) {
            result = num.ymHyphen()
        } else {
            result = this.slice(0, -1)
        }
    } else {
        result = this.slice(0, -1)
    }
    return result
}

// 사업자 번호 형식 XXX-XX-XXXXX
String.prototype.businessCode = function() {
    let result, val = this

    if (!val) return val

    let num = val.replace(/-/g, '')

    if (!isNaN(num.charAt(num.lnegth - 1))) {
        if (num.length >= 4 && num.length < 6) {
            result = num.substr(0, 3)
            result = result + '-' + num.substr(3, 2)
        } else if (num.length >= 6 && num.length < 11) {
            result = num.substr(0, 3)
            result = result + '-' + num.substr(3, 2)
            result = result + '-' + num.substr(5, 5)
        } else if (num.length > 12) {
            result = this.slice(0, -1)
        } else {
            result = this
        }
    } else {
        result = this.slice(0, -1)
    }

    return result
}

String.prototype.longtermAuthMask = function() {
    let val = this
    let result = null
    if (!val) return val
    let num = val.replace(/[^0-9]/g, '')
    if (num.length >= 1 && num.length <= 10) {
        result = num.replace(/(.{1,10})/, "L$1")
    } else if (num.length > 10 && num.length <= 13) {
        result = num.replace(/(.{1,10})(.{3})/, "L$1-$2")
    } else if (num.length > 13) {
        result = num.substr(0, 13).replace(/(.{1,10})(.{3})/, "L$1-$2")
    }
    return result
}

//날짜폼 YYYY-MM-DD
String.prototype.mdKor = function() {
    if (this) {
        var yyyy = this.slice(0, 4)
        var mm = this.slice(4, 6)
        var dd = this.slice(6, 8)

        return mm + '월 ' + dd + '일'
    }
}

//날짜폼 YYYY-MM-DD
String.prototype.ymdHyphen = function() {
    if (this) {
        var yyyy = this.slice(0, 4)
        var mm = this.slice(4, 6)
        var dd = this.slice(6, 8)

        return [yyyy, mm, dd].join("-")
    }
}

//날짜폼 YYYY-MM-DD
String.prototype.ymdKor = function() {
    if (this) {
        var yyyy = this.slice(0, 4)
        var mm = this.slice(4, 6)
        var dd = this.slice(6, 8)

        return yyyy + '년 ' + mm + '월 ' + dd + '일'
    }
}

//날짜폼 YYYY년 MM월
String.prototype.ymKor = function() {
    if (this) {
        var yyyy = this.slice(0, 4)
        var mm = this.slice(4, 6)

        return yyyy + '년 ' + mm + '월'
    }
}

//날짜폼 YYYY-MM
String.prototype.ymHyphen = function() {
    if (this) {
        var yyyy = this.slice(0, 4)
        var mm = this.slice(4, 6)

        return [yyyy, mm].join("-")
    }
}

//날짜폼 YYYY.MM.DD
String.prototype.ymdPoint = function() {
    if (this) {
        var yyyy = this.slice(0, 4)
        var mm = this.slice(4, 6)
        var dd = this.slice(6, 8)

        return [yyyy, mm, dd].join(".")
    }
}

//날짜폼 YYYY.MM
String.prototype.ymPoint = function() {
    if (this) {
        var yyyy = this.slice(0, 4)
        var mm = this.slice(4, 6)

        return [yyyy, mm].join(".")
    }
}

//날짜폼 YYYYMMDD
String.prototype.ymdSplit = function() {
    if (this) {
        let [year, month, day] = this.split("-")
        return `${year}${month}${day}`
    }
}

//날짜폼 YYYY
String.prototype.YYYY = function() {
    if (this) {
        return this.slice(0, 4)
    }
}

//날짜폼 MMDD
String.prototype.MMDD = function() {
    if (this) {
        return this.substr(4, 7)
    }
}

//날짜폼 YYYY-MM-DD hh:mm:ss
String.prototype.ymdhmsMask = function() {
    if (this) {
        let YYYY = this.substr(0, 4)
        let MM = this.substr(4, 2)
        let DD = this.substr(6, 2)
        let hh = this.substr(8, 2)
        let mm = this.substr(10, 2)
        let ss = this.substr(12, 2)

        return `${[YYYY, MM, DD].join("-")}` + ` ${[hh, mm, ss].join(":")}`
    }
}

//날짜폼 hh:mm
String.prototype.Hm = function() {
    if (this) {
        let hh = this.substr(8, 2)
        let mm = this.substr(10, 2)

        return `${[hh, mm].join(":")}`
    }
}

//날짜폼 hh:mm:ss
String.prototype.Hms = function() {
    if (this) {
        let hh = this.substr(8, 2)
        let mm = this.substr(10, 2)
        let ss = this.substr(12, 2)

        return `${[hh, mm, ss].join(":")}`
    }
}

//시간형식 HH:MM (keyup event)
String.prototype.timeMask = function() {
    let val = this
    let result = null
    let num = val.replace(/:/g, '')
    if (!isNaN(num.charAt(num.length - 1))) {
        if (num.length < 3) {
            result = num
        } else if (num.length < 5) {
            result = num.hmColon()
        } else {
            result = num.hmColon()
        }
    } else {
        result = this.slice(0, -1)
    }
    return result
}

//시간형식 HH:MM:SS (timeline) 
String.prototype.timeSecondMask = function() {
    let val = this
    let result = null
    let num = val.replace(/:/g, '')
    if (!isNaN(num.charAt(num.length - 1))) {
        if (num.length < 3) {
            result = num
        } else if (num.length < 5) {
            result = num.hmColon()
        } else {
            result = num.hmColon()
        }
    } else {
        result = this.slice(0, -1)
    }
    return result
}

//시간폼 HH:MM
String.prototype.hmColon = function() {
    if (this) {
        let hh = this.substr(0, 2)
        let mm = this.substr(2, 2)
        return `${hh}:${mm}`
    }
}

//시간폼 HH:MM:SS
String.prototype.hmsColon = function() {
    if (this) {
        let hh = this.substr(0, 2)
        let mm = this.substr(2, 2)
        let ss = this.substr(4, 2)

        return `${hh}:${mm}:${ss}`
    }
}

//만나이 구하기 (만 67세)
String.prototype.age = function() {
        if (!this) return
        if (this.length < 7) return
        let today = new Date()
        let birth = null
        let year = null
        let month = null
        let day = null
        let age = null
        let val = this.replace(/[^0-9]/g, '')

        if (this) {
            year = val.substr(0, 4)
            month = val.substr(4, 2)
            day = val.substr(6, 2)
            birth = new Date(year, String(Number(month) - 1), day)
            age = today.getFullYear() - birth.getFullYear()
            let m = today.getMonth() - birth.getMonth()
            if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
                age--;
            }
        }
        return age
    },

    //게시판글 등의 작성일 이후 30일이 지났는지 계산
    String.prototype.passedDays = function() {
        if (this) {
            let param = this.substr(0, 4) + '-' + this.substr(4, 2) + '-' + this.substr(6, 2) + ' ' +
                this.substr(8, 2) + ':' + this.substr(10, 2) + ':' + this.substr(12, 2)
            let old = new Date(param)
            let now = new Date()
            let gap = now.getTime() - old.getTime()

            let min = Math.floor(gap / 1000 / 60) < 1 ? 1 : Math.floor(gap / 1000 / 60)
            let hour = null
            let day = null
            let week = null
            if (min >= 60) {
                hour = Math.floor(min / 60)
                if (hour >= 24) {
                    day = Math.floor(hour / 24)
                    if (day >= 7) {
                        week = Math.floor(day / 7)
                    }
                }
            }
            return day > 30 ? false : true
        }
    }

//게시판글 등의 작성일로 부터 지난기간 계산 (4주까지 계산)
String.prototype.createCompare = function() {
    if (this) {
        let param = this.substr(0, 4) + '-' + this.substr(4, 2) + '-' + this.substr(6, 2) + ' ' +
            this.substr(8, 2) + ':' + this.substr(10, 2) + ':' + this.substr(12, 2)
        let old = new Date(param)
        let now = new Date()
        let gap = now.getTime() - old.getTime()

        let min = Math.floor(gap / 1000 / 60) < 1 ? 1 : Math.floor(gap / 1000 / 60)
        let hour = null
        let day = null
        let week = null
        if (min >= 60) {
            hour = Math.floor(min / 60)
            if (hour >= 24) {
                day = Math.floor(hour / 24)
                if (day >= 7) {
                    week = Math.floor(day / 7)
                }
            }
        }
        if (week && week > 4) {
            return null
        } else {
            return week ? week + '주전' : day ? day + '일전' : hour ? hour + '시간전' : min + '분전'
        }
    }
}

// 게시글판의 작성일로 부터 30일이 지났는지 체크
String.prototype.updateCompare = function() {
    if (this) {
        let param = this.substr(0, 4) + '-' + this.substr(4, 2) + '-' + this.substr(6, 2) + ' ' +
            this.substr(8, 2) + ':' + this.substr(10, 2) + ':' + this.substr(12, 2)
        let old = new Date(param)
        let now = new Date()
        let gap = now.getTime() - old.getTime()

        let min = Math.floor(gap / 1000 / 60) < 1 ? 1 : Math.floor(gap / 1000 / 60)
        let hour = null
        let day = null
        let week = null
        if (min >= 60) {
            hour = Math.floor(min / 60)
            if (hour >= 24) {
                day = Math.floor(hour / 24)
                if (day >= 7) {
                    week = Math.floor(day / 7)
                }
            }
        }
        return day > 30 ? false : true //30일 초과시 수정,삭제 불가
    }
}

//회원가입 생년월일 + 주민번호 앞자리 00000000-0
String.prototype.formatRegBirthday = function() {
    let rrb = this
    if (!rrb) return rrb
    rrb = rrb.replace(/[^0-9]/g, "")
    let res = ''

    if (rrb.length < 8) {
        res = rrb
    } else {
        if (rrb.length === 8) {
            res = rrb.substr(0, 8) + "-" + rrb.substr(8);
        } else if (rrb.length === 9) {
            res = rrb.substr(0, 8) + "-" + rrb.substr(8);
        } else {
            let temp = rrb.substr(0, 9);
            res = temp.substr(0, 8) + "-" + temp.substr(8);
        }
    }
    return res
}

//특수문자 포함여부
String.prototype.includeSpecial = function() {
    return this.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi, "") ?
        true :
        false;
}

//특수문자 제거
String.prototype.removeSpecial = function() {
    return this.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi, "");
}

//Byte사이즈
String.prototype.bytes = function() {

    let s = this

    return s.split("").map((s) => s.charCodeAt(0))
        .reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0);
}

//주민번호 확인 (keyup event)
String.prototype.juminNo = function() {
    let jumin = this
    if (!jumin) return jumin
    else jumin = jumin.replace(/[^0-9]/g, "")

    let number = ''

    if (jumin.length < 7) {
        number = jumin
    } else if (jumin.length <= 13) {
        number = jumin.substr(0, 6) + '-' + jumin.substr(6, 7)
    } else if (jumin.length > 13) {
        number = jumin.substr(0, 6) + '-' + jumin.substr(6, 7)
    }
    return number
}

//모바일 번호 (keyup event)
String.prototype.mobileMask = function() {
    let phoneNo = this

    if (!phoneNo) return phoneNo;
    else phoneNo = phoneNo.replace(/[^0-9]/g, "")

    let number = ""

    if (phoneNo.length < 3) {
        number = phoneNo;
    } else {
        if (phoneNo.substr(0, 2) == "02") {
            if (phoneNo.length <= 5) {
                number = phoneNo.substr(0, 2) + "-" + phoneNo.substr(2, 3);
            } else if (phoneNo.length > 5 && phoneNo.length <= 9) {
                number = phoneNo.substr(0, 2) + "-" + phoneNo.substr(2, 3) + "-" + phoneNo.substr(5);
            } else if (phoneNo.length > 9) {
                number = phoneNo.substr(0, 2) + "-" + phoneNo.substr(2, 4) + "-" + phoneNo.substr(6);
            }
        } else {
            if (phoneNo.length < 8) {
                number = phoneNo;
            } else if (phoneNo.length == 8) {
                number = phoneNo.substr(0, 4) + "-" + phoneNo.substr(4);
            } else if (phoneNo.length == 9) {
                number = phoneNo.substr(0, 3) + "-" + phoneNo.substr(3, 3) + "-" + phoneNo.substr(6);
            } else if (phoneNo.length == 10) {
                number = phoneNo.substr(0, 3) + "-" + phoneNo.substr(3, 3) + "-" + phoneNo.substr(6);
            } else if (phoneNo.length > 10) {
                number = phoneNo.substr(0, 3) + "-" + phoneNo.substr(3, 4) + "-" + phoneNo.substr(7, 4);
            }
        }
    }

    return number;
}

//파일 확장자 확인 및 이미지파일 리턴
String.prototype.extention = function() {
    let str = this
    let type = null
    let src = null
    if (str === 'pdf') {
        type = 'pdf'
    } else if (str === 'txt') {
        type = 'txt' // 텍스트문서
    } else if (fileExtention.word.indexOf(str) !== -1) {
        type = 'doc' // MS워드  
    } else if (fileExtention.ppt.indexOf(str) !== -1) {
        type = 'ppt' // 프레젠테이션
    } else if (fileExtention.hwp.indexOf(str) !== -1) {
        type = 'hwp' // 한글문서
    } else if (fileExtention.image.indexOf(str) !== -1) {
        type = 'img' // 이미지
    } else if (fileExtention.excel.indexOf(str) !== -1) {
        type = 'excel' // 엑셀
    } else if (fileExtention.zip.indexOf(str) !== -1) {
        type = 'zip'
    }

    switch (type) {
        case 'pdf':
            src = require('@/assets/images/pdf.png');
            break
        case 'excel':
            src = require('@/assets/images/excel.png');
            break
        case 'txt':
            src = require('@/assets/images/txt.png');
            break
        case 'doc':
            src = require('@/assets/images/word.png');
            break
        case 'ppt':
            src = require('@/assets/images/ppt.png');
            break
        case 'hwp':
            src = require('@/assets/images/hangle.png');
            break
        case 'zip':
            src = require('@/assets/images/zip.png')
            break
    }

    return src
}

//모바일 번호 하이픈 (값 조회 후 화면에 보여줄때 하이픈 추가)
String.prototype.mobileHyphen = function() {
    if (this) {
        let no = this
        return no.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3")
    } else return
}

//card number with empty space
String.prototype.cardNoSpace = function() {
    // 4자리 숫자마다 공백 추가
    if (this) {
        let no = this
        return no.replace(/\B(?=(\d{4})+(?!\d))/g, " ")
    }
}

//card number with hyphen
String.prototype.cardNoHyphen = function() {
    // 4자리 숫자마다 공백 추가
    if (this) {
        let no = this
        return no.replace(/\B(?=(\d{4})+(?!\d))/g, "-")
    }
}

//직원 간호,치위생사 등 타입 체크(간호면허, 자격 명칭 변경시 필요)
String.prototype.staffTypeCheck = function() {
    let str = null
    if (!this) return
    if (this === '31' ||
        this === '32' ||
        this === '33' ||
        this === '34') {
        str = '간호면허번호'
    } else {
        str = '간호자격번호'
    }
    return str
}

//모든 데이터 특수문자, 양옆 공백 제거
String.prototype.clearValue = function() {
    return this.match(regPattern) ? this.replace(regPattern, '').trim() : this
}

String.prototype.clearKor = function() {
    return this.replace(/[^0-9]/g, '').trim()
}

//암호화
String.prototype.encrypt = function() {
    return sha256(this)
}

//
Number.prototype.isEmpty = function() {
    //check and confirm empty
    let n = this;

    if (n !== null && typeof n !== "undefined" && n !== 0) return false;
    else return true;
}

// return amount each 3td with comma
Number.prototype.amount = function() {
    let amount = this;
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

String.prototype.minusNum = function() {
    let amount = this
    let front = false
    if (amount) {
        if (amount.substr(0, 1) === '-') {
            front = true
        }
        return front ? '-' + amount.clearValue().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : amount.clearValue().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
}


// WEBPACK FOOTER //
// ./src/utils/prototypes.js